/*
 * Baut die mailto-Adresse im Browser zusammen.
 *
 * Im ausgelieferten HTML steht nur der umgedrehte, Base64-kodierte String —
 * Harvester, die den Quelltext abgrasen, kommen damit nicht an die Adresse.
 * Das href setzen wir, sobald die Seite steht: Der Link verhaelt sich dann wie
 * jeder andere Link (Ziel in der Statusleiste, Rechtsklick-Kopieren,
 * Mittelklick). Die Interaktions-Handler bleiben als Netz fuer Links, die
 * spaeter nachgeladen werden.
 */
(function () {
  if (window.konturaMailtoReady) return;
  window.konturaMailtoReady = true;

  var SELECTOR = 'a[data-kontura-mailto]';

  function decode(value) {
    try {
      return atob(value).split('').reverse().join('');
    } catch (error) {
      return '';
    }
  }

  function reveal(link) {
    if (!link || link.dataset.konturaMailtoDone === 'true') return;

    var address = decode(link.dataset.konturaMailto);
    if (!address) return;

    var href = 'mailto:' + address;
    var subject = link.dataset.konturaMailtoSubject;
    if (subject) {
      // Der Betreff ist bereits url-kodiert abgelegt, atob liefert ihn zurueck.
      href += '?subject=' + atob(subject);
    }

    link.setAttribute('href', href);
    link.removeAttribute('role');
    link.dataset.konturaMailtoDone = 'true';
  }

  function onEvent(event) {
    var link = event.target.closest ? event.target.closest(SELECTOR) : null;
    if (link) reveal(link);
  }

  function revealAll() {
    var links = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < links.length; i++) reveal(links[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', revealAll);
  } else {
    revealAll();
  }

  ['pointerover', 'focusin', 'touchstart'].forEach(function (type) {
    document.addEventListener(type, onEvent, { passive: true, capture: true });
  });

  // Klick ohne vorheriges Hover (Tastatur-Enter, synthetischer Klick): erst
  // aufloesen, dann die Navigation selbst ausloesen.
  document.addEventListener(
    'click',
    function (event) {
      var link = event.target.closest ? event.target.closest(SELECTOR) : null;
      if (!link || link.dataset.konturaMailtoDone === 'true') return;

      event.preventDefault();
      reveal(link);
      if (link.getAttribute('href') !== '#') {
        window.location.href = link.getAttribute('href');
      }
    },
    true
  );
})();
